<template>
  <div class="bookingActivities-addOrEditActivity">
    <div class="page_title flex_between">
      <span>{{ pageTitle }}</span>
      <el-button type="primary"
                 style="width: 120px"
                 size="small"
                 @click="back">返回</el-button>
    </div>

    <div style="padding: 20px">
      <div class="container">
        <el-form :model="activityInfo"
                 :rules="rules"
                 ref="ruleForm1"
                 label-width="150px"
                 class="rule-form"
                 :disabled="disabledType == 3">
          <div class="title">基本信息</div>

          <el-form-item label="活动名称"
                        prop="act_name">
            <el-input v-model="activityInfo.act_name"
                      maxlength="20"
                      style="width: 420px"
                      placeholder="不超过20个字"
                      size="small"></el-input>
          </el-form-item>

          <el-form-item label="活动备注">
            <el-input v-model="activityInfo.act_remark"
                      maxlength="20"
                      style="width: 420px"
                      placeholder="不超过20个字"
                      size="small"></el-input>
          </el-form-item>

          <el-form :model="activityInfo"
                   :rules="rules"
                   ref="ruleForm"
                   label-width="150px"
                   class="rule-form"
                   :disabled="disabledType == 3 || disabledType == 2">
            <el-form-item label="活动时间"
                          prop="act_time">
              <el-date-picker style="width: 420px"
                              size="small"
                              v-model="activityInfo.act_time"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              @input="$forceUpdate()"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <el-form-item label="活动链接"
                          prop="act_url">
              <el-input v-model="activityInfo.act_url"
                        style="width: 420px"
                        placeholder="请输入活动链接"
                        size="small"></el-input>
              <span class="prompt">用于用户端或小程序展示活动的页面URL，每次活动需单独定制</span>
            </el-form-item>

            <el-form-item label="活动说明"
                          prop="act_desc"
                          class="act-description">
              <el-input type="textarea"
                        v-model="activityInfo.act_desc"
                        maxlength="500"
                        :rows="4"
                        size="small"
                        placeholder="请填写">
              </el-input>
            </el-form-item>

            <el-form-item label="活动图片"
                          prop="act_image"
                          class="act-img">
              <div class="uploadImg-box">
                <UploadImg :f_thumb="activityInfo.act_image"
                           :f_thumb_str="activityInfo.act_image_str"
                           @emitImg="emitActImg"></UploadImg>
                <div class="prompt">建议750*514</div>
              </div>
            </el-form-item>

            <el-form-item label="用户填写信息"
                          prop="user_info"
                          class="user-info">
              <el-checkbox-group v-model="activityInfo.user_info"
                                 size="small"
                                 @change="changeInfoType">
                <el-checkbox label="name">姓名</el-checkbox>
                <el-checkbox label="age">年龄</el-checkbox>
                <el-checkbox label="sex">性别</el-checkbox>
                <el-checkbox label="phone">手机号</el-checkbox>
                <el-checkbox label="id_card">身份证号</el-checkbox>
                <el-checkbox label="address">收货地址</el-checkbox>
              </el-checkbox-group>
              <div class="prompt">注：若勾选收货地址，姓名、手机号必须一同勾选</div>
            </el-form-item>
          </el-form>

          <!-- 奖励信息 -->
          <div style="margin-bottom:20px">
            <span class="title">活动物品</span>
            <el-button type="primary"
                       size="medium"
                       style="margin-left:20px"
                       @click="addItem"
                       :disabled="disabledType == 3">添加物品</el-button>
          </div>

          <div v-for="(item,index) in activityInfo.item_list"
               :key="index"
               class="list_item">

            <div>

              <el-form :model="activityInfo"
                       :rules="rules"
                       ref="ruleForm"
                       label-width="150px"
                       class="rule-form"
                       :disabled="disabledType == 3 || disabledType == 2">
                <el-form-item label="物品名称"
                              label-width="110px"
                              :prop="`item_list.${index}.item_name`"
                              :rules="rules.item_name">
                  <el-input v-model="item.item_name"
                            maxlength="25"
                            style="width: 320px"
                            placeholder="不超过25个字"
                            size="small"></el-input>
                </el-form-item>
                <el-form-item label="物品单位"
                              label-width="110px"
                              :prop="`item_list.${index}.item_unit`"
                              :rules="rules.item_unit">
                  <el-input v-model="item.item_unit"
                            maxlength="5"
                            style="width: 320px"
                            placeholder="不超过5个字"
                            size="small"></el-input>
                </el-form-item>
                <el-form-item label="物品图片说明"
                              label-width="110px"
                              :prop="`item_list.${index}.item_image`"
                              class="goods-img"
                              :rules="rules.item_image">
                  <div class="uploadImg-box">
                    <UploadImg :f_thumb="item.item_image"
                               :f_thumb_str="item.item_image_str"
                               :index="index"
                               @emitImg="emitGoodsImg"></UploadImg>
                    <!-- <div class="prompt">建议750*514</div> -->
                  </div>
                </el-form-item>
              </el-form>

              <el-form-item label="限购数量"
                            label-width="110px"
                            :prop="`item_list.${index}.max_buy`">
                <el-input-number v-model="item.max_buy"
                                 size="small"
                                 step-strictly
                                 :step="1"
                                 :min="0"
                                 @blur="maxBuyBlur(item.max_buy,index)"
                                 :controls="false"
                                 placeholder="请输入大于0的正整数"
                                 style="width:200px"></el-input-number>
              </el-form-item>

              <el-form :model="activityInfo"
                       :rules="rules"
                       ref="ruleForm"
                       label-width="150px"
                       class="rule-form"
                       :disabled="disabledType == 3 || disabledType == 2">
                <el-form-item label="金额"
                              label-width="110px"
                              :prop="`item_list.${index}.price`">
                  <el-select v-model="item.price_type"
                             size="small"
                             placeholder="请选择"
                             style="width:100px;margin-right:10px">
                    <el-option label="总金额"
                               :value="1"></el-option>
                    <el-option label="单价"
                               :value="2"></el-option>
                  </el-select>
                  <el-input-number v-model="item.price"
                                   size="small"
                                   step-strictly
                                   :precision="2"
                                   :step="0.01"
                                   :min="0"
                                   :controls="false"
                                   placeholder="请输入大于或等于0"
                                   style="width:200px"></el-input-number>
                </el-form-item>
              </el-form>
            </div>
            <div class="btnBox">
              <el-button type="danger"
                         size="small"
                         style="margin-bottom:25px"
                         @click="delItem('item_list',index)"
                         :disabled="item.disabled || disabledType == 3">删除</el-button>
              <el-button plain
                         size="small"
                         style="margin-bottom:5px"
                         @click="changeSort('item_list',1,index)"
                         v-if="index!=0"
                         :disabled="item.disabled || disabledType == 3">上移</el-button>
              <el-button plain
                         size="small"
                         @click="changeSort('item_list',2,index)"
                         v-if="index!=activityInfo.item_list.length-1"
                         :disabled="item.disabled || disabledType == 3">下移</el-button>
            </div>
          </div>

        </el-form>
        <div v-if="disabledType !=3 "
             style="margin-top:50px;padding-left:260px">
          <el-button type="primary"
                     style="width:100px"
                     @click="submitForm">保 存</el-button>
          <!-- <el-button plain
                     style="width:100px">取 消</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import marketing from '@/api/marketing.js';
import common from '@/api/common.js';
import UploadImg from '@/components/uploadImg/index';
export default {
  components: {
    UploadImg
  },
  data() {
    const validateTime = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请选择时间'));
      } else {
        callback();
      }
    };
    const validateGoodsName = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入物品名称'));
      } else {
        callback();
      }
    };
    const validateGoodsUnit = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入物品单位'));
      } else {
        callback();
      }
    };
    const validateGoodsImg = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请上传'));
      } else {
        callback();
      }
    };
    return {
      interfaceName: 'uploadExcleDoctorHeartPhone',
      activityInfo: {
        act_name: '',
        act_remark: '',
        act_time: '',
        act_url: '',
        act_desc: '',
        act_image: '',
        act_image_str: '',
        user_info: [],
        item_list: [
          {
            item_name: '',
            item_unit: '',
            item_image: '',
            item_image_str: '',
            max_buy: undefined,
            price_type: 1,
            price: undefined
          }
        ]
      },
      rules: {
        act_name: [
          {
            required: true,
            max: 20,
            message: '请输入活动名称',
            trigger: 'blur'
          }
        ],
        act_time: [
          { required: true, validator: validateTime, trigger: 'change' }
        ],
        act_url: [
          { required: true, message: '请填写活动链接', trigger: 'blur' }
        ],
        act_image: [{ required: true, message: '请上传', trigger: 'change' }],
        act_desc: [
          { required: true, message: '输入活动说明', trigger: 'blur' }
        ],
        item_name: [
          {
            required: true,
            validator: validateGoodsName,
            trigger: 'blur'
          }
        ],
        item_unit: [
          {
            required: true,
            validator: validateGoodsUnit,
            trigger: 'blur'
          }
        ],
        item_image: [
          { required: true, validator: validateGoodsImg, trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    doctor_length() {
      if (this.info.doctor_string) {
        let arr = this.info.doctor_string.split(',');
        return arr.length;
      } else {
        return 0;
      }
    },
    disabledType() {
      // 1:add 2:edit 3:look 4:edit(未开始)
      return this.$route.query.type;
    },
    pageTitle() {
      switch (Number(this.$route.query.type)) {
        case 1:
          return '新增预约活动';
        case 2:
          return '编辑预约活动';
        case 3:
          return '查看预约活动';
        case 4:
          return '编辑预约活动';
      }
    }
  },
  created() {
    if (
      this.$route.query.type == 2 ||
      this.$route.query.type == 3 ||
      this.$route.query.type == 4
    ) {
      this.getDetail();
      console.log(1);
    }
  },
  methods: {
    // 回显
    getDetail() {
      let { act_id } = this.$route.query;
      const loading = this.$loading();
      marketing
        .getDetail({ act_id })
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.activityInfo = data;
            this.activityInfo.act_time = [
              dayjs.unix(this.activityInfo.start_time).format('YYYY-MM-DD'),
              dayjs.unix(this.activityInfo.end_time).format('YYYY-MM-DD')
            ];
            this.activityInfo.user_info =
              this.activityInfo.user_info.split(',');
            if (this.disabledType == 3) {
              this.activityInfo.item_list = data.item_list.map((item) => {
                item.disabled = true;
                return item;
              });
            } else {
              this.activityInfo.item_list = data.item_list;
            }
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 活动图片
    emitActImg(data) {
      let { pic, path } = data;
      this.activityInfo.act_image = pic;
      this.activityInfo.act_image_str = path;
    },
    // 用户填写信息类型
    changeInfoType(val) {
      if (val.includes('address')) {
        if (!val.includes('name')) {
          this.activityInfo.user_info.push('name');
        }
        if (!val.includes('phone')) {
          this.activityInfo.user_info.push('phone');
        }
      }
    },
    // 物品图片
    emitGoodsImg(data, index) {
      let { pic, path } = data;
      this.activityInfo.item_list[index].item_image = pic;
      this.activityInfo.item_list[index].item_image_str = path;
    },
    // 限购数量
    maxBuyBlur(val, index) {
      console.log(val, index);
      if (!val) {
        this.activityInfo.item_list[index].max_buy = undefined;
      }
    },
    //提交添加
    submitForm() {
      console.log();
      this.$refs['ruleForm1'].validate((valid) => {
        if (valid) {
          let params = _.omit(this.activityInfo, ['act_time', 'act_image_str']);
          params.start_time = this.activityInfo.act_time[0];
          params.end_time = this.activityInfo.act_time[1];
          params.user_info = params.user_info.join(',');
          params.item_list = params.item_list.map((item) => {
            item = _.omit(item, ['item_image_str']);
            return item;
          });
          let interfaceName = 'create';
          if (this.disabledType == 2 || this.disabledType == 4) {
            interfaceName = 'modify';
            params.act_id = this.$route.query.act_id;
          } else {
            interfaceName = 'create';
          }
          marketing[interfaceName](params).then((res) => {
            if (res.code == 0) {
              this.$message.success(
                `${interfaceName == 'create' ? '添加' : '修改'}成功`
              );
              this.back();
            }
          });
        }
      });
    },
    //增加节点
    addItem() {
      if (this.activityInfo.item_list.length === 20) {
        this.$message.warning('最多可添加20个物资');
        return;
      }
      let data = {
        item_name: '',
        item_unit: '',
        item_image: '',
        item_image_str: '',
        max_buy: undefined,
        price_type: 1,
        price: undefined
      };
      this.activityInfo.item_list.push(data);
    },
    //删除节点
    delItem(key, index) {
      if (this.activityInfo[key].length === 1) {
        this.$message.warning('至少有一个物资');
        return;
      }
      this.activityInfo[key].splice(index, 1);
    },
    changeSort(key, type, index) {
      let data = this.activityInfo[key][index];
      this.activityInfo[key].splice(index, 1);
      //上移
      if (type == 1) {
        this.activityInfo[key].splice(index - 1, 0, data);
      }
      //下移
      if (type == 2) {
        this.activityInfo[key].splice(index + 1, 0, data);
      }
    },
    back() {
      history.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 16px;
}
.bookingActivities-addOrEditActivity {
  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
  }
  .rule-form {
    .act-description {
      margin-bottom: 26px;
      ::v-deep.el-form-item__content {
        height: 100px;
      }
      .el-textarea {
        width: 420px;
      }
    }
    .act-img {
      .uploadImg-box {
        display: flex;
        align-items: flex-end;
        .prompt {
          height: 30px;
        }
      }
      ::v-deep.el-form-item__content {
        height: 110px;
      }
    }
    .user-info {
      ::v-deep.el-form-item__content {
        height: 110px;
      }
    }
    .goods-img {
      .uploadImg-box {
        display: flex;
        align-items: flex-end;
        .prompt {
          height: 30px;
        }
      }
      ::v-deep.el-form-item__content {
        height: 110px;
      }
    }
  }
  .list_item {
    padding: 20px;
    background: #f5f5f5;
    width: 700px;
    border-radius: 10px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btnBox {
      padding-right: 30px;
    }
  }
}
</style>
